import styles from './participantCard.module.css';
import { Icons } from '../../../../code/IconHandler';
export default function ParticipantCard({ participant, onEdit, onDelete }) {
    return (
        <div className={styles.card}>
            <div className={styles.header}>
                <div className={styles.left}>
                    <div className={styles.avatar}>{participant.vornameKind.charAt(0)}{participant.nachnameKind.charAt(0)}</div>
                    <h3>{participant.vornameKind} {participant.nachnameKind}</h3>

                </div>

                <div className={styles.actions}>
                    <button className={styles.edit} onClick={onEdit}><Icons.Edit /></button>
                    <button className={styles.delete} onClick={onDelete}><Icons.Delete /></button>
                </div>
            </div>
            <div className={styles.details}>
                <div><strong>Geburtsdatum:</strong> {new Date(participant.birthdate).toLocaleDateString('de-DE', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                })}</div>
                <div><strong>T-Shirt:</strong> {participant.shirt}</div>
                <div><strong>Mitglied:</strong> {participant.mitglied ? 'Ja' : 'Nein'}</div>
            </div>
            <div className={styles.details}>
                <div><strong>Erziehungsperson:</strong> {participant.vornameErziehung} {participant.nachnameErziehung}</div>
                <div><strong>Telefon:</strong> {participant.telefon}</div>
                <div><strong>E-Mail:</strong> {participant.email}</div>
            </div>
        </div>
    );
}